import React from 'react';
import { useNavigate } from 'react-router-dom';
import snipeLogo from '../../assets/snipe_logo.png';

function Disclaimer() {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-[#020817] text-white">
            {/* Gradient Background */}
            <div className="fixed inset-0 z-0 bg-[#020817]">
                <div className="absolute top-0 left-1/4 w-96 h-96 bg-emerald-500/10 rounded-full blur-3xl"></div>
                <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-teal-500/10 rounded-full blur-3xl"></div>
            </div>

            {/* Content */}
            <div className="relative z-10">
                {/* Header */}
                <nav className="container mx-auto px-4 sm:px-6 py-4 flex items-center justify-between border-b border-slate-800/50">
                    <button onClick={() => navigate('/')} className="cursor-pointer">
                        <img src={snipeLogo} alt="Snipe Logo" className="h-16 sm:h-20 w-auto object-contain" />
                    </button>
                    <button 
                        onClick={() => navigate('/')}
                        className="bg-gradient-to-r from-emerald-600 to-teal-600 px-6 sm:px-8 py-2 sm:py-3 rounded-lg font-semibold text-white hover:from-emerald-700 hover:to-teal-700 transition duration-200 shadow-lg shadow-emerald-500/20 hover:shadow-emerald-500/30"
                    >
                        Back to Home
                    </button>
                </nav>

                {/* Disclaimer Content */}
                <div className="container mx-auto px-4 sm:px-6 py-12 max-w-4xl text-left">
                    <div className="bg-gradient-to-br from-[#0f172a] to-[#020617] rounded-2xl border border-slate-800/50 p-6 sm:p-10 text-left">
                        <h1 className="text-2xl sm:text-3xl font-bold mb-6 text-white text-left">
                            Disclaimer
                        </h1>

                        {/* Header Info */}
                        <div className="bg-slate-800/30 rounded-lg p-4 border border-slate-700/50 mb-6 text-left">
                            <p className="text-xs sm:text-sm mb-1.5 text-slate-400 text-left"><strong className="text-slate-300">Last updated:</strong> 16/01/2026</p>
                            <p className="text-xs sm:text-sm mb-1.5 text-slate-400 text-left"><strong className="text-slate-300">Business:</strong> SNIPEAIO PTY LTD (ABN 29 685 306 978 | ACN 685 306 978)</p>
                            <p className="text-xs sm:text-sm text-slate-400 text-left"><strong className="text-slate-300">Contact:</strong> <a href="mailto:info@snipeaio.com" className="text-emerald-400 hover:text-emerald-300 underline">info@snipeaio.com</a></p>
                        </div>

                        <div className="space-y-6 text-slate-300 text-left">
                            {/* Section 1 */}
                            <section className="text-left">
                                <h2 className="text-base sm:text-lg font-semibold mb-3 text-white text-left">Not a bookmaker</h2>
                                <p className="text-sm leading-relaxed text-left">
                                    Snipe provides software and informational tools to help users assess betting markets. We are not a bookmaker. We do not take, place, or accept bets. We are not affiliated with or endorsed by any wagering operator.
                                </p>
                            </section>

                            {/* Section 2 */}
                            <section className="text-left">
                                <h2 className="text-base sm:text-lg font-semibold mb-3 text-white text-left">Informational only</h2>
                                <p className="text-sm leading-relaxed text-left">
                                    All information, alerts, and content are provided for informational purposes only. You should not rely on the Service as the only basis for any decision.
                                </p>
                            </section>

                            {/* Section 3 */}
                            <section className="text-left">
                                <h2 className="text-base sm:text-lg font-semibold mb-3 text-white text-left">No guarantees</h2>
                                <p className="text-sm leading-relaxed text-left">
                                    Betting involves risk. You can lose money. We do not guarantee profit, wins, or outcomes. Past performance is not indicative of future results.
                                </p>
                            </section>

                            {/* Section 4 */}
                            <section className="text-left">
                                <h2 className="text-base sm:text-lg font-semibold mb-3 text-white text-left">Data delays and errors</h2>
                                <p className="text-sm leading-relaxed text-left">
                                    Odds and markets change quickly. Data and alerts may be delayed, incomplete, inaccurate, or unavailable. You are responsible for verifying information before acting.
                                </p>
                            </section>

                            {/* Section 5 */}
                            <section className="text-left">
                                <h2 className="text-base sm:text-lg font-semibold mb-3 text-white text-left">Bookmaker decisions</h2>
                                <p className="text-sm leading-relaxed text-left">
                                    Bookmakers can change odds, rules, limits, promotions, or account access at any time (including voiding bets or restricting accounts). We are not responsible for bookmaker actions or decisions.
                                </p>
                            </section>

                            {/* Section 6 */}
                            <section className="text-left">
                                <h2 className="text-base sm:text-lg font-semibold mb-3 text-white text-left">Third parties</h2>
                                <p className="text-sm leading-relaxed text-left">
                                    We may rely on third-party platforms and providers (including Discord, payment processors, hosting, APIs). We are not responsible for third-party outages, policy changes, or errors.
                                </p>
                            </section>
                        </div>
                    </div>

                    {/* Back to Home Button at bottom */}
                    <div className="text-center mt-8 sm:mt-12">
                        <button
                            onClick={() => navigate('/')}
                            className="bg-gradient-to-r from-emerald-600 to-teal-600 px-8 py-3 rounded-lg font-semibold text-white hover:from-emerald-700 hover:to-teal-700 transition duration-200 shadow-lg shadow-emerald-500/20 hover:shadow-emerald-500/30"
                        >
                            Back to Home
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Disclaimer;

